import { FelaCSS } from '@bridebook/ui';
import { IMAGES_BASE_URL } from '@bridebook/toolbox/src/buildImageUrl';
import { createAnimation } from '@bridebook/web/app-shared/components/animations/helpers/create-animation';
import { fadeInAnimation } from '@bridebook/web/app-shared/components/animations/helpers/fade-animations';

const starsImages = `${IMAGES_BASE_URL}/assets/onboarding/graphics`;

interface IStyles {
  wrapper: FelaCSS;
  stars: FelaCSS;
}

const styles = (): IStyles => ({
  wrapper: {
    ...fadeInAnimation(0.5),
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    overflow: 'hidden',
    pointerEvents: 'none',
    zIndex: -1,
  },

  stars: {
    width: '100%',
    height: '100%',
    backgroundImage: `url("${starsImages}/stars-mobile.png")`,
    backgroundSize: '100%',
    backgroundRepeat: 'repeat',
    ...createAnimation(
      {
        '0%': {
          opacity: 0.2,
        },
        '100%': {
          opacity: 0.7,
        },
      },
      {
        animationIterationCount: 'infinite',
        animationDirection: 'alternate-reverse',
      },
    )(2),

    desktopDesign: {
      backgroundImage: `url("${starsImages}/stars-desktop.png")`,
      backgroundSize: '60%',
    },
  },
});

export default styles;
